import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TheTradeDesk from './TheTradeDesk';

export default class TheTradeDeskWrapper extends Component {
    render() {
        return(
            <TheTradeDesk config={this.props.config} reportEvent={this.props.reportEvent(this.props.config.advertiser_id)} />
        );
    }
}

TheTradeDeskWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
